import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

function RecuperarContrasenia() {

    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const navigate = useNavigate();
    const enviarCodigo = async (event) => {
        event.preventDefault();
        try {
            const DTO = {
                email: email,
                codigo: 0,
                contrasenia: ""
            };
            let respuesta = await fetch(`https://pideapi2025.azurewebsites.net/api/Usuarios/CodigoDeRecuperacion`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(DTO)
            });

            if (respuesta.ok) {
                setStep(2);
            } else {
                // Mostrar mensaje de error
                console.error('Error al enviar el código de verificación');
            }
        } catch (error) {
            console.error(error);
            // Mostrar mensaje de error
        }
    };

    const verificarCodigo = async (event) => {
        event.preventDefault();
        try {
            const DTO = {
                email: email,
                codigo: code,
                contrasenia: ""
            };
            let respuesta = await fetch(`https://sistemadesemapideploy.azurewebsites.net/api/Usuarios/VerificarCodigo`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(DTO)
            });

            if (respuesta.ok) {
                setStep(3);
            } else {
                alert('Código incorrecto');
                // Mostrar mensaje de error
            }
        } catch (error) {
            console.error(error);
            alert('Código incorrecto');
            // Mostrar mensaje de error
        }
    };

    const cambiarContrasenia = async (event) => {
        event.preventDefault();

        if (password ===confirmPassword) {
            try {
                const DTO = {
                    email: email,
                    codigo: code,
                    contrasenia: password
                };
                let respuesta = await fetch(`https://sistemadesemapideploy.azurewebsites.net/api/Usuarios/CambiarContreasenia`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(DTO)
                });

                if (respuesta.ok) {
                    alert('Contraseña restablecida correctamente');
                    navigate("/")
                } else {
                    console.error('Error al restablecer la contraseña');
                   
                }
            } catch (error) {
                console.error(error);
                // Mostrar mensaje de error
            }
        } else {
            alert('Las contraseñas no coinciden');
        }
    };

    return (
        <div className="container mt-5">
            {step ===1 && (
                <form onSubmit={enviarCodigo} className="w-50 mx-auto">
                    <div className="mb-3">
                        <label className="form-label">Ingresa tu correo electrónico:</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary">Enviar</button>
                </form>
            )}

            {step ===2 && (
                <form onSubmit={verificarCodigo} className="w-50 mx-auto">
                    <div className="mb-3">
                        <label className="form-label">Ingresa el código de verificación:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary">Verificar</button>
                </form>
            )}

            {step ===3 && (
                <form onSubmit={cambiarContrasenia} className="w-50 mx-auto">
                    <div className="mb-3">
                        <label className="form-label">Ingresa tu nueva contraseña:</label>
                        <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Confirma tu nueva contraseña:</label>
                        <input
                            type="password"
                            className="form-control"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary">Restablecer contraseña</button>
                </form>
            )}
        </div>
    );
}

export default RecuperarContrasenia;
